import { useCallback, useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Celebration } from "./Celebration";
import { JourneyTimeline } from "./Journey";
import { RolePulse } from "./RoleBadge";
import { FeeWaivedStatus } from "./FeeWaiver";

export function DirectorJourney({ api }) {
  const [data, setData] = useState(null);
  const [playing, setPlaying] = useState(null);
  const [pulse, setPulse] = useState(false);
  const load = useCallback(() => api.get("/director/journey").then((r) => setData(r.data)).catch(() => {}), [api]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { const h = () => setTimeout(load, 600); window.addEventListener("director-journey-refresh", h); return () => window.removeEventListener("director-journey-refresh", h); }, [load]);
  useEffect(() => { if (data?.pending_celebration && !playing) setPlaying(data.pending_celebration); }, [data, playing]);
  useEffect(() => { if (data?.role_pulse_pending && data.role && !playing && !pulse) setPulse(true); }, [data, playing, pulse]);
  const done = async () => {
    const n = playing.n;
    setPlaying(null);
    try { await api.post("/director/journey/ack", { stage: n }); } catch { /* ignore */ }
    load();
  };
  const pulseDone = async () => { setPulse(false); try { await api.post("/director/role/pulse-ack"); } catch { /* ignore */ } load(); };
  const certificate = async () => {
    try {
      const r = await api.get("/director/journey/certificate.pdf", { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url; a.download = "Vinci_Induction_Certificate.pdf"; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
    } catch (e) { toast.error(e.response?.status === 409 ? "Certificate unlocks at Stage 7." : "Could not generate the certificate"); }
  };
  return (
    <>
      {playing && <Celebration stage={playing} name={data?.name || ""} shareholdingPct={data?.shareholding_pct} onDone={done} />}
      {pulse && !playing && <RolePulse role={data.role} onDone={pulseDone} />}
      <div className="rounded-2xl border border-[#C9A961]/20 bg-black/40 p-6 mb-8" data-testid="director-journey-card">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-4 flex-wrap">
            <div className="font-serif text-xl text-[#F5F5F0]">Your Vinci journey</div>
          </div>
          {data?.inducted && (
            <button data-testid="journey-certificate-download" onClick={certificate}
                    className="inline-flex items-center gap-2 rounded-full border border-[#C9A84C]/60 text-[#C9A84C] px-4 py-2 font-grotesk text-[9px] uppercase tracking-[0.28em] hover:bg-[#C9A84C] hover:text-black transition-colors">
              <Download size={11} /> Induction certificate
            </button>
          )}
        </div>
        <JourneyTimeline data={data} />
        <FeeWaivedStatus phases={data?.vcb_fees} />
      </div>
    </>
  );
}
